import { Button, Card, Col, DatePicker, DatePickerProps, Row } from "antd";
import DemoDualAxesComponent from "../../Layout/Chart/CustomColumnLine";
import {
  MessageOutlined,
  PhoneOutlined,
  UserOutlined,
  BookOutlined,
} from "@ant-design/icons";
import { useEffectOnce } from "react-use";
import { getUsers } from "../user/services";
import { getPostStatistical, getPosts, getViewStatistical, getViewStatisticalDay } from "../post/services";
import { getRecruiments } from "../recruiment/services";
import { getContacts } from "../contact/services";
import { useState } from "react";
import { Link } from "react-router-dom";
import { IPostStatistical } from "../../models/post";
import { useAppSelector } from "../../app/hooks";
import { IUserState } from "../user/propState";
import { isCheckPermisson } from "../../utils";
import { PERMISSION_ENUM } from "../../utils/permisson.enum";
import ReactChartComponent from "../../Layout/Chart/CustomColumnLine/indexReact-chart";
import dayjs from "dayjs";

const DashBoardPage = () => {
  const [countUserState, setUserState] = useState<number>(0);
  const [countPostState, setPostState] = useState<number>(0);
  const [countRecruimentState, setRecruimentState] = useState<number>(0);
  const [countContactState, setContactState] = useState<number>(0);
  const [countDateViewState, setCountDateViewState] = useState<number>(0);
  const [dataColum, setdataColum] = useState<any[]>([]);
  const userState = useAppSelector<IUserState>((state) => state.screens.user);
  const permissionObj = userState.permissionObj;
  const isPostList = isCheckPermisson(permissionObj, PERMISSION_ENUM.POST_LIST);
  const isUserList = isCheckPermisson(permissionObj, PERMISSION_ENUM.USER_LIST);
  const isRecruimentList = isCheckPermisson(permissionObj, PERMISSION_ENUM.RECRUIMENT_LIST);
  const isContactList = isCheckPermisson(permissionObj, PERMISSION_ENUM.CONTACT_LIST);
  const [yearStr, setYearStr] = useState(new Date().getFullYear());
  var year = new Date().getFullYear();
  var day = new Date().getDay();
  const getCount = async () => {
    // var year = year;
    const query: any = {
      skip: 0,
      limit: 0,
    };

    getUsers({ ...query }).then((r: any) => setUserState(r?.count || 0));
    getPosts({ ...query, language: "vi" }).then((r: any) =>
      setPostState(r?.count || 0)
    );
    getRecruiments({ ...query }).then((r: any) =>
      setRecruimentState(r?.count || 0)
    );
    getContacts({ ...query }).then((r: any) => setContactState(r?.count || 0));
    getViewStatisticalDay({ year, language: "vi", day: day}).then((r:any) => setCountDateViewState(r?.data[0]?.count || 0)).catch((e) => [] as IPostStatistical[]);
    const [dataYear, view] = await Promise.all([
      getPostStatistical({ year, language: "vi" })
        .then((r) => r.data as IPostStatistical[])
        .catch((e) => [] as IPostStatistical[]),
      getViewStatistical({ year, language: "vi" })
        .then((r) => r.data as IPostStatistical[])
        .catch((e) => [] as IPostStatistical[]),
    ]);
    const dataColum: any[] = [];
    for (let index = 1; index <= 12; index++) {
      const time = index < 10 ? "0" + index + "-" + year : index + "-" + year;
      const monthYear = dataYear.find((f) => f.time === time);
      const monthView = view.find((f) => f.time === time);
      const monthStatis: any = { time };
      monthStatis[year] = 0;
      monthStatis['view'] = 0;
      if (monthYear) monthStatis[year] = monthYear?.count || 0;
      if (monthView) monthStatis['view'] = monthView?.count || 0;
      dataColum.push(monthStatis);
    }
    setdataColum(dataColum);
  };

  useEffectOnce(() => {
    getCount();
  });
  const onChange: DatePickerProps['onChange'] = (date, dateString) => {
    setYearStr(new Date(dateString).getFullYear());
    year = new Date(dateString).getFullYear();
    getCount();
  };
  return (
    <>
      <Row gutter={16}>
        <Col span={6}>
          <Card
            bordered
            style={{
              backgroundColor: "#007bff",
            }}
          >
            <Link key="post" to={{ pathname: isPostList ? "/post" : "" }} title="Bài viết">
              <Row className="ant-row-start ant-row-middle">
                <Col>
                  <h5 className="mb-0 text-white text-xl">{countPostState}</h5>
                  <small className="text-white-50">Bài viết</small>
                </Col>
                <span className="mr-auto"></span>
                <Col>
                  <Button className="border-none text-white">
                    <BookOutlined />
                  </Button>
                </Col>
              </Row>
            </Link>
          </Card>
        </Col>
        <Col span={4}>
          <Card
            bordered
            style={{
              backgroundColor: "#faad14",
            }}
          >
            <Link key="user" to={{ pathname: isUserList ? `/user` : "" }} title="Người dùng">
              <Row className="ant-row-start ant-row-middle">
                <Col>
                  <h5 className="mb-0 text-white text-xl">{countUserState}</h5>
                  <small className="text-white-50">Người dùng</small>
                </Col>
                <span className="mr-auto"></span>
                <Col>
                  <Button className="border-none text-white">
                    <UserOutlined />
                  </Button>
                </Col>
              </Row>
            </Link>
          </Card>
        </Col>
        <Col span={4}>
          <Card
            bordered
            style={{
              backgroundColor: "rgb(51,51,51)",
            }}
          >
            <Link
              key="recruiment"
              to={{ pathname: isRecruimentList ? `/recruiment` : "" }}
              title="Tuyển dụng"
            >
              <Row className="ant-row-start ant-row-middle">
                <Col>
                  <h5 className="mb-0 text-white text-xl">
                    {countRecruimentState}
                  </h5>
                  <small className="text-white-50">Tuyển dụng</small>
                </Col>
                <span className="mr-auto"></span>
                <Col>
                  <Button className="border-none text-white">
                    <PhoneOutlined />
                  </Button>
                </Col>
              </Row>
            </Link>
          </Card>
        </Col>
        <Col span={4}>
          <Card
            bordered
            style={{
              backgroundColor: "#f5222d",
            }}
          >
            <Link key="contact" to={{ pathname: isContactList ? `/contact` : "" }} title="Liên hệ">
              <Row className="ant-row-start ant-row-middle">
                <Col>
                  <h5 className="mb-0 text-white text-xl">
                    {countContactState}
                  </h5>
                  <small className="text-white-50">Liên hệ</small>
                </Col>
                <span className="mr-auto"></span>
                <Col>
                  <Button className="border-none text-white">
                    <MessageOutlined />
                  </Button>
                </Col>
              </Row>
            </Link>
          </Card>
        </Col>
        <Col span={6}>
          <Card
            bordered
            style={{
              backgroundColor: "#2296f5",
            }}
          >
            <Link key="contact" to={{ pathname: "" }} title="Thống kê">
              <Row className="ant-row-start ant-row-middle">
                <Col>
                  <h5 className="mb-0 text-white text-xl">
                    {countDateViewState}
                  </h5>
                  <span className="text-white">Lượt xem trong ngày</span>
                </Col>
              </Row>
            </Link>
          </Card>
        </Col>
        <Col span={24} className="mt-4">
          <Card>
            <div><DatePicker placeholder={"Chọn năm"} onChange={onChange} picker="year" defaultValue={dayjs()} /></div>
            <ReactChartComponent dataColum={dataColum} year={yearStr}/>
          </Card>
        </Col>
      </Row>
    </>
  );
};

export default DashBoardPage;
